export default {
  //第三方账户接口
  getBankAccountsOthersList: '/api/bankAccountsOther/getBankAccountsOtherList', //获取第三方账户列表
  addBankAccountsOthers: '/api/bankAccountsOther/addBankAccountsOther', //添加第三方账户
  editBankAccountsOthers: '/api/bankAccountsOther/editBankAccountsOther', //编辑第三方账户
  delBankAccountsOthers: '/api/bankAccountsOther/delBankAccountsOther', //删除第三方账户
  //账户管理
  getBankAccountsList: '/api/bankAccounts/getBankAccountsList', //获取账户列表
  addBankAccounts: '/api/bankAccounts/addBankAccounts', //添加账户
  editBankAccounts: '/api/bankAccounts/editBankAccounts', //编辑账户
  delBankAccounts: '/api/bankAccounts/delBankAccounts', //删除账户
  //开票信息维护
  getInvoiceTitleList: '/api/invoiceTitle/getInvoiceTitleList', //获取开票信息列表
  addInvoiceTitle: '/api/invoiceTitle/addInvoiceTitle', //添加开票信息
  editInvoiceTitle: '/api/invoiceTitle/editInvoiceTitle', //编辑开票信息
  delInvoiceTitle: '/api/invoiceTitle/delInvoiceTitle', //删除开票信息
  //外经证
  getCrossRegionalCertList: '/api/financeTaxCrossRegional/getFinanceTaxCrossRegionalList', //获取外经证列表
  setCrossRegionalCert: '/api/financeTaxCrossRegional/addFinanceTaxCrossRegional', //添加外经证
  editCrossRegionalCert: '/api/financeTaxCrossRegional/editFinanceTaxCrossRegional', //编辑外经证
  removeCrossRegionalCert: '/api/financeTaxCrossRegional/delFinanceTaxCrossRegional', //删除外经证
  //开票余额
  getInvoiceLimitList: '/api/financeInvoiceLimit/getInvoiceLimitList', //获取开票余额列表
  editInvoiceLimit: '/admin/invoiceLimit/editInvoiceLimit', //编辑开票余额    没用到
  getCompanyDetail: '/api/company/getCompanyDetail', //获取公司开票额度详情
  clickRecover: '/api/financeInvoiceLimit/clickRecover', //恢复每月默认额度
  editLimit: '/api/financeInvoiceLimit/editLimit', //编辑基本额度
  tempAdd: '/api/financeInvoiceLimit/tempAdd', //新增临时额度
  //合同
  getContractList: '/api/contract/getContractList', //获取合同列表
  addContract: '/api/contract/addContract', //添加合同
  editContract: '/api/contract/editContract', //编辑合同
  delContract: '/api/contract/delContract', //删除合同
  addContractInfo: '/admin/contract/addContractInfo', //添加增补合同
  //完税证明
  addDutyPaidProof: '/api/dutyPaidProof/addDutyPaidProof', //添加完税证明
  addDutyPaidProofBase64: '/api/dutyPaidProof/addDutyPaidProofBase64', //添加完税证明base64
  editDutyPaidProof: '/api/dutyPaidProof/editDutyPaidProof', //编辑完税证明
  delDutyPaidProof: '/api/dutyPaidProof/delDutyPaidProof', //删除完税证明
  getDutyPaidProofList: '/api/dutyPaidProof/getDutyPaidProofList', //获取完税证明列表
  getDutyPaidProofDetail: '/api/dutyPaidProof/getDutyPaidProofDetail', //获取完税证明详情   凭证税种列表
  editTaxCategories: '/api/dutyPaidProof/editDutyPaidProofDetail', //修改完税证明详情列表   编辑税种明细
  moveDutyPaidProof: '/api/dutyPaidProof/moveDutyPaidProof',//移动完税证明
  //发票列表
  getInvoiceList: '/api/invoice/getInvoiceList', //获取发票列表
  addAndBindInvoiceInput: '/api/invoice/addAndBindInvoiceInput', //添加发票
  getInvoiceIdentifyContent: '/api/invoice/getInvoiceIdentifyContent', //获取发票识别内容
  getInvoiceIdentifyContent_ver: '/api/invoice/getInvoiceIdentifyContent_ver',
  getInvoiceDetailList: '/api/invoice/getInvoiceDetailList', //获取清单详情
  //发起开票
  addMakeInvoice: '/api/makeInvoice/addMakeInvoice', //发起开票
  getMakeInvoiceList: '/api/makeInvoice/getMakeInvoiceList', //获取发起开票列表
  delMakeInvoice: '/api/makeInvoice/delMakeInvoice', //删除发起开票
  editMakeInvoice: '/api/makeInvoice/editMakeInvoice', //编辑发起开票
  someInvoiceCompleteTask: '/api/makeInvoice/someInvoiceCompleteTask', //完成开票任务
  //获取开票条件
  getProjectTypes: '/api/project/getProjectTypes',
  //获取公司下所有合同
  getOrdinaryContractList: '/api/contract/getOrdinaryContractList',
  //设置公司可开票税率
  setCompanyTax: '/api/company/setCompanyTax',
  //获取公司可开票税率
  getCompanyTaxArray: '/api/company/getCompanyTaxArray',
  //无任务上传发票
  uploadOutputNoTask: '/api/makeInvoice/uploadOutputNoTask',
  //获取开票任务的发票列表
  getTaskInvoiceList: '/api/makeInvoice/getTaskInvoiceList',
  //查询开票任务的多个附件
  getInvoiceFileListByInvoiceId: '/api/invoice/getInvoiceFileListByInvoiceId',
  //删除任务中的发票
  delTaskInvoice: '/api/makeInvoice/delTaskInvoice',

  // 流程基点和流程连接接口
  processNodes: '/api/process-nodes', // 流程基点列表
  addProcessNode: '/api/process-nodes/add', // 添加流程基点
  updateProcessNode: '/api/process-nodes/update', // 更新流程基点
  deleteProcessNode: '/api/process-nodes/delete', // 删除流程基点

  processConnections: '/api/process-connections', // 流程连接列表
  addProcessConnection: '/api/process-connections/add', // 添加流程连接
  updateProcessConnection: '/api/process-connections/update', // 更新流程连接
  deleteProcessConnection: '/api/process-connections/delete', // 删除流程连接

  //工作流
  saveFlow: '/api/process-flow/save',
  getFlow: '/api/process-flow/detail',

  //报销模块接口
  create: '/api/reimbursements/create',
  list: '/api/reimbursements/list',

  //流程定义管理模块接口
  definitions: '/api/process-definitions', //流程定义列表
  getProcessDefinitionsList: '/api/process-definitions/getProcessDefinitionsList',
  add: '/api/process-definitions', //创建流程定义
  update: '/api/process-definitions/update', //更新流程定义
  deletes: '/api/process-definitions/delete', //删除流程定义

  //流程节点管理
  process_nodes: '/api/process-nodes', //获取流程节点列表

  //生成工资表
  getWageScheduleListList: '/api/wageScheduleList/getWageScheduleListList',
  addWageScheduleList: '/api/wageScheduleList/addWageScheduleList',
  editWageScheduleList: '/api/wageScheduleList/editWageScheduleList',
  delWageScheduleList: '/api/wageScheduleList/delWageScheduleList',

  //银行流水
  getFinanceTransactionLogList: '/api/financeTransactionLog/getFinanceTransactionLogList',
  addFinanceTransactionLog: '/api/financeTransactionLog/addFinanceTransactionLog',
  editFinanceTransactionLog: '/api/financeTransactionLog/editFinanceTransactionLog',

  //非现金流水
  getFinanceNonCashList: '/api/financeNonCash/getFinanceNonCashList',

  //贷款记录
  getFinanceLoanRecordList: '/api/financeLoanRecord/getFinanceLoanRecordList',
  //还款记录
  getFinanceLoanRepaymentRecordList: '/api/financeLoanRepaymentRecord/getFinanceLoanRepaymentRecordList',
  //新发票识别
  getInvoiceIdentifyContentExist: '/api/invoice/getInvoiceIdentifyContentExist',
  //发票绑定合同
  bindInputInvoiceAddContract: '/api/invoice/bindInputInvoiceAddContract',

  //对账单管理
  getStatementList: '/api/statement/getStatementList', //获取对账单列表
  addStatement: '/api/statement/addStatement', //添加对账单
  editStatement: '/api/statement/editStatement', //编辑对账单
  delStatement: '/api/statement/delStatement', //删除对账单

  //结算单管理
  getSettlementList: '/api/settlement/getSettlementList', //获取结算单列表
  addSettlement: '/api/settlement/addSettlement', //添加结算单
  editSettlement: '/api/settlement/editSettlement', //编辑结算单
  delSettlement: '/api/settlement/delSettlement', //删除结算单

  //新增信用贷款
  addFinanceLoanRecordCredit: '/api/financeLoanRecord/addFinanceLoanRecordCredit',
  //还款
  repayLoan: '/api/financeLoanRepaymentRecord/repayLoan',
  //项目流水
  getFinanceTransactionProjectLogList: '/api/financeTransactionProjectLog/getFinanceTransactionProjectLogList',
  //合同首付款记录
  getContractPaymentRecordList: '/api/contractPaymentRecord/getContractPaymentRecordList',
  //内部往来
  getFinanceNbwlAccountList: '/api/financeNbwlAccount/getFinanceNbwlAccountList',
  //充值  提现  转账
  addFinanceTransactionNbwlLog: '/api/financeTransactionNbwlLog/addFinanceTransactionNbwlLog',
  //查询账户流水
  getFinanceTransactionNbwlLogList: '/api/financeTransactionNbwlLog/getFinanceTransactionNbwlLogList',
  //更新账户余额
  updateAccountBalance: '/api/bankAccounts/updateAccountBalance',
  //行政费用
  getFinanceExpensesAdminList: '/api/financeExpensesAdmin/getFinanceExpensesAdminList',
  addFinanceExpensesAdmin: '/api/financeExpensesAdmin/addFinanceExpensesAdmin',
  statementFinanceExpensesAdmin: '/api/financeExpensesAdmin/statementFinanceExpensesAdmin',
  updateFinanceExpensesAdmin: '/api/financeExpensesAdmin/updateFinanceExpensesAdmin',
  deleteFinanceExpensesAdmin: '/api/financeExpensesAdmin/deleteFinanceExpensesAdmin',
  //获取已删除的行政费用
  getFinanceExpensesAdminDelList: '/api/financeExpensesAdmin/getFinanceExpensesAdminDelList',
  //资产流水
  getFinanceCashNonCashList: '/api/financeNonCash/getFinanceCashNonCashList',
  //抵扣
  deductionInputInvoice: '/api/invoice/deductionInputInvoice',
  //公司下所有发票
  getInvoiceListAll: '/api/invoice/getInvoiceListAll',
  //其他费用
  getFinanceExpensesOtherList: '/api/financeExpensesOther/getFinanceExpensesOtherList',
  getFinanceExpensesOtherDelList: '/api/financeExpensesOther/getFinanceExpensesOtherDelList',
  addFinanceExpensesOther: '/api/financeExpensesOther/addFinanceExpensesOther',
  statementFinanceExpensesOther: '/api/financeExpensesOther/statementFinanceExpensesOther',
  updateFinanceExpensesOther: '/api/financeExpensesOther/updateFinanceExpensesOther',
  deleteFinanceExpensesOther: '/api/financeExpensesOther/deleteFinanceExpensesOther',
  //查询其他票据
  getFinanceBillList: '/api/financeBill/getFinanceBillList',
  updateFinanceBill: '/api/financeBill/updateFinanceBill',
  deleteFinanceBill: '/api/financeBill/deleteFinanceBill',
  addFinanceBill: '/api/financeBill/addFinanceBill',
  getCompanyTaxUse: '/api/company/getCompanyTaxUse',
  //抵扣
  addFinanceComTaxDeduction: '/api/financeComTaxDeduction/addFinanceComTaxDeduction',
  getFinanceComTaxDeductionList: '/api/financeComTaxDeduction/getFinanceComTaxDeductionList',
  //成本使用
  addFinanceComCostUse: '/api/financeComCostUse/addFinanceComCostUse',
  getFinanceComCostUseList: '/api/financeComCostUse/getFinanceComCostUseList',
  //合同下上传进项票
  addAndBindInvoiceInputContract: '/api/invoice/addAndBindInvoiceInputContract',
  //外经证核销
  chargeOff: '/api/financeTaxCrossRegional/chargeOff',
  //撤回核销
  recall: '/api/financeTaxCrossRegional/recall',
  //退款
  refund: '/api/contractPaymentRecord/refund',
  //绑定合同
  bindInvoiceContractBatch: '/api/invoice/bindInvoiceContractBatch',
  //合同对账单
  getCompanyReconciliationStatementList: '/api/contractReconciliationStatement/getCompanyReconciliationStatementList',
  addCompanyReconciliationStatement: '/api/contractReconciliationStatement/addCompanyReconciliationStatement',
  getContractAmount: '/api/contract/getContractAmount',
  //项目合同下添加人员
  addWagePersonInfo: '/api/wagePersonInfo/addWagePersonInfo',
  getWagePersonInfoList: '/api/wagePersonInfo/getWagePersonInfoList',
  editWagePersonInfo: '/api/wagePersonInfo/editWagePersonInfo',
  delWagePersonInfo: '/api/wagePersonInfo/delWagePersonInfo',
  //获取账户余额
  getBankAccountsBalance: '/api/bankAccounts/getBankAccountsBalance',

  //项目详情
  getProjectDetail: '/api/project/getProjectDetail',

  //内部转账
  internalCompanyTransfer: '/api/financeTransactionLog/internalCompanyTransfer',

  //发票数据统计
  getInvoiceTaxSummary: '/api/invoice/getInvoiceTaxSummary',
  //行政税费统计
  getExpensesAdminTaxSummary: '/api/financeExpensesAdmin/getExpensesAdminTaxSummary',
  //其他费用统计
  getExpensesOtherTaxSummary: '/api/financeExpensesOther/getExpensesOtherTaxSummary',
  //进项票据统计
  getBillTaxSummary: '/api/financeBill/getBillTaxSummary',
  //发票根据时间查询统计
  getInvoiceTaxSummaryDate: '/api/invoice/getInvoiceTaxSummaryDate',
  //其他票据根据时间查询统计
  getBillTaxSummaryDate: '/api/financeBill/getBillTaxSummaryDate',
  //行政税费时间查询数据统计
  getExpensesAdminTaxSummaryDate: '/api//financeExpensesAdmin/getExpensesAdminTaxSummaryDate',
  //其他费用时间查询数据统计
  getExpensesOtherTaxSummaryDate: '/api/financeExpensesOther/getExpensesOtherTaxSummaryDate',
  //项目流水查询数据统计
  getTransactionProjectSummary: '/api/financeTransactionProjectLog/getTransactionProjectSummary',
  //项目流水时间查询数据统计
  getTransactionProjectSummaryDate: '/api/financeTransactionProjectLog/getTransactionProjectSummaryDate',
  //银行流水查询数据统计
  getTransactionSummary: '/api/financeTransactionLog/getTransactionSummary',
  //银行流水时间查询数据统计
  getTransactionSummaryDate: '/api/financeTransactionLog/getTransactionSummaryDate',
  //贷款结清、
  settle: '/api/financeLoanRecord/settle',
  //还款
  addRepayLoan: '/api/financeLoanRepaymentRecord/addRepayLoan',
  //项目查询参考数据
  getProjectReference: '/api/project/getProjectReference',
  //合同查询参考数据
  getContractReference: '/api/contract/getContractReference',
  //转入/转出
  transferFromNbwlToProject: '/api/financeTransactionProjectLog/transferFromNbwlToProject',
  //项目转项目
  transferFromProjectToProject: '/api/financeTransactionProjectLog/transferFromProjectToProject',
  //社保缴纳
  addFinanceTransactionSocialSecurityLog: '/api/financeTransactionSocialSecurityLog/addFinanceTransactionSocialSecurityLog',
  //社保查询
  getFinanceTransactionSocialSecurityLogList: '/api/financeTransactionSocialSecurityLog/getFinanceTransactionSocialSecurityLogList',
  //社保缴费
  payFinanceTransactionSocialSecurityLog: '/api/financeTransactionSocialSecurityLog/payFinanceTransactionSocialSecurityLog',
  //社保缴费退款
  refundFinanceTransactionSocialSecurityLog: '/api/financeTransactionSocialSecurityLog/refundFinanceTransactionSocialSecurityLog',
  //完税凭证入库
  payDutyPaidProof: '/api/dutyPaidProof/payDutyPaidProof',
  //完税凭证退库
  refundDutyPaidProof: '/api/dutyPaidProof/refundDutyPaidProof',
  //行政税费复制
  copyFinanceExpensesAdmin: '/api/financeExpensesAdmin/copyFinanceExpensesAdmin',
  //其他费用复制
  copyFinanceExpensesOther: '/api/financeExpensesOther/copyFinanceExpensesOther',
  // 发票迁移
  moveInvoice: '/api/invoice/moveInvoice',

  //新增银行流水
  addBankTransactionLog: '/api/financeTransactionLog/addBankTransactionLog',
  //合同付款 绑定银行流水
  addContractReceiptRecordBind: '/api/contractPaymentRecord/addContractReceiptRecordBind',
  //银行流水查询
  getFinanceFlowBindList: '/api/financeFlowBind/getFinanceFlowBindList',
  //冲红
  reverseFinanceFlowBind: '/api/financeFlowBind/reverseFinanceFlowBind',
  //编辑内部往来流水
  editFinanceTransactionNbwlLog: '/api/financeTransactionNbwlLog/editFinanceTransactionNbwlLog',
  //工资账户增删改查
  getUserBankAccountsByCard: '/api/bankAccountsOther/getUserBankAccountsByCard',
  addUserBankAccount: '/api/bankAccountsOther/addUserBankAccount',
  editUserBankAccount: '/api/bankAccountsOther/editUserBankAccount',
  delUserBankAccount: '/api/bankAccountsOther/delUserBankAccount',
  //薪资管理
  getInInsuranceEmployees: '/api/socialInsuranceTransferRecords/getInInsuranceEmployees',
  //员工离职
  employeeResign: '/api/companyPersonnel/employeeResign',

  //临时接口
  getBankStatementDetailList:'/api/bankStatementDetail/getBankStatementDetailList',

};
